<template>
  <v-dialog v-model="model"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            scrollable>
    <v-card tile flat class="pa-0">
      <v-toolbar dense max-height="48px" flat dark color="primary" style="height:48px; margin-top: 56px; margin-bottom:-1px;">
        <v-toolbar-title><slot name="title" /></v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-0">
        <v-row style="height: calc(100% + 1px );">
          <dialog-bar @close="model = false">
            <slot name="title"></slot>
          </dialog-bar>
          <v-col cols="12" class="pa-0">
            <v-card v-if="!!$slots.subtitle" flat dark tile class="text-left px-4 pb-4 pt-2" :style="$attrs['body-style']" color="primary">
              <slot name="subtitle" />
            </v-card>
            <v-card light flat tile class="d-flex flex-column text-center rounded-t-lg mt-n4" color="white" style="width: 100%;">
              <slot />
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-row v-if="!!$slots.footer || !!$slots['footer-left'] || !!$slots['footer-right']" no-gutters align="center" class="pa-6" style="background-color: rgba(255, 255, 255, 0.9)">

          <!--footer: alinha ao centro - usado sozinho-->
          <v-col v-if="!!$slots.footer" cols="12"><slot name="footer" /></v-col>

          <!--footer-left: alinha esquerda-->
          <v-col v-if="!$slots.footer" cols="auto" class="mr-auto">
            <slot name="footer-left" />
          </v-col>

          <!--footer-right: alinha direita-->
          <v-col v-if="!$slots.footer" cols="auto">
            <slot name="footer-right" />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
};
</script>
